import React from "react";
import { Provider } from "react-redux";
import Home from "./pages/Home";
import Redirect from "./pages/Redirect";
import { Route, BrowserRouter } from "react-router-dom";
import { BASENAME } from "./consts/constants";
import { IApplicationState } from "./redux/reducers";
import { Store } from "redux";

interface IProps {
  store: Store<IApplicationState>;
}

const App: React.FC<IProps> = ({ store }) => (
  <Provider store={store}>
    <BrowserRouter basename={BASENAME}>
      <div className="App">
        <Route path='/:prestador' component={Redirect}></Route>
        <Route path='/*' component={Home}></Route>
      </div>
    </BrowserRouter>
  </Provider>
);

export default App;
